/** Shared by the eK Link Login Page list and its edit dialog. */

export const CARD_KINDS = [
    { value: 'NEWS', label: 'News', hint: 'Latest eKutir news and progress' },
    { value: 'SERVICE', label: 'Services', hint: 'Other eKutir services and Initiatives' },
    { value: 'RECOMMENDATION', label: 'Recommendations', hint: 'Suggestions for the user, e.g. an app they do not have yet' },
];

/** The fields the backend saves, from a card as it lists it. */
export const toRequest = (card) => ({
    kind: card.kind,
    title: card.title,
    body: card.body || null,
    linkUrl: card.linkUrl || null,
    linkLabel: card.linkLabel || null,
    imageUrl: card.imageUrl || null,
    personas: card.personas || [],
    hideIfAppUrl: card.hideIfAppUrl || null,
    active: Boolean(card.active),
    sortOrder: Number.isInteger(card.sortOrder) ? card.sortOrder : 0,
    startsOn: card.startsOn || null,
    endsOn: card.endsOn || null,
});
